<template>
    <div>
        <b-modal
            no-fade
            size="lg"
            id="modal-tarefa-padrao"
            no-close-on-esc
            no-close-on-backdrop
            title="Tarefa Padrão"
            @show="loadCombos"
        >
            <div v-show="isLoading" class="loading" id="loading">
                <div><b-spinner variant="primary" label="Spinning"></b-spinner> Aguarde...</div>
            </div>
            <div v-show="!isLoading">
                <b-row>
                    <b-col lg="2">
                        <b-form-group label="Código" label-size="sm" label-for="tarefa_id">
                            <b-form-input
                                maxlength="10"
                                size="sm"
                                id="tarefa_id"
                                v-model="tarefa.tarefa_id"
                                disabled
                                trim
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col lg="5">
                        <b-form-group label="Tipo" label-size="sm" label-for="ind_tipo">
                            <b-form-select
                                size="sm"
                                v-model="tarefa.ind_tipo"
                                @change="loadCombos"
                                :options="[
                                    { value: 1, text: 'OBRAS' },
                                    { value: 2, text: 'SERVIÇO NÃO CONSULTORIA' },
                                    { value: 3, text: 'CONSULTORIA FIRMAS' },
                                ]"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col lg="5">
                        <b-form-group label="Tipo de Revisão" label-size="sm" label-for="ind_tp_revisao">
                            <b-form-select
                                size="sm"
                                v-model="tarefa.ind_tp_revisao"
                                @change="loadCombos"
                                :options="[
                                    { value: 1, text: 'EX-ANTE' },
                                    { value: 2, text: 'EX-POST' },
                                    { value: 3, text: 'NACIONAL' },
                                ]"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12">
                        <b-form-group label="Descrição" label-size="sm" label-for="descricao">
                            <b-textarea
                                size="sm"
                                id="descricao"
                                maxlength="255"
                                v-model="tarefa.descricao"
                                :disabled="action === 'view'"
                                trim
                                no-resize
                            ></b-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12">
                        <b-form-group label="Predecessora" label-size="sm" label-for="predecessora_id">
                            <b-form-select
                                size="sm"
                                id="predecessora_id"
                                v-model="tarefa.predecessora_id"
                                :options="tarefas"
                                value-field="tarefa_id"
                                :disabled="action === 'view'"
                                text-field="descricao2"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="3" lg="3">
                        <b-form-group
                            :label="tarefa.ind_tipo == 1 ? 'Dias p/Conclusão LPI' : 'Dias p/Conclusão'"
                            label-size="sm"
                            label-for="dias"
                        >
                            <b-form-input
                                size="sm"
                                id="dias"
                                maxlength="10"
                                type="number"
                                step="1"
                                min="0"
                                max="999999"
                                v-model="tarefa.dias"
                                :disabled="action === 'view'"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3" lg="3" v-show="tarefa.ind_tipo == 1">
                        <b-form-group label="Dias p/Conclusão LPN" label-size="sm" label-for="dias2">
                            <b-form-input
                                size="sm"
                                id="dias2"
                                maxlength="10"
                                type="number"
                                step="1"
                                min="0"
                                max="999999"
                                v-model="tarefa.dias2"
                                :disabled="action === 'view'"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3" lg="3">
                        <b-form-group label="Ordem" label-size="sm" label-for="ordem_id">
                            <b-form-input
                                size="sm"
                                id="ordem_id"
                                maxlength="10"
                                type="number"
                                step="1"
                                min="0"
                                max="999999"
                                v-model="tarefa.ordem_id"
                                :disabled="action === 'view'"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="12" lg="12">
                        <b-form-group label="Controle da Tarefa" label-size="sm" label-for="controle_id">
                            <b-form-select
                                size="sm"
                                id="controle_id"
                                name="controle_id"
                                :disabled="action === 'view'"
                                v-model="tarefa.controle_id"
                            >
                                <b-form-select-option value="">Sem Controle</b-form-select-option>
                                <b-form-select-option value="CHAMAMENTO_PUBLICO"
                                    >Licitação - Dt Chamamento Público</b-form-select-option
                                >
                                <b-form-select-option value="ENTREGA_MI"
                                    >Licitação - Dt Entrega da MI</b-form-select-option
                                >
                                <b-form-select-option value="CBR1_DATA"
                                    >Licitação - 1ª Não Objeção - Dt CBR</b-form-select-option
                                >
                                <b-form-select-option value="PUBLIC_LICITACAO"
                                    >Licitação - Dt Publicação</b-form-select-option
                                >
                                <b-form-select-option value="ABERT_LICITACAO"
                                    >Licitação - Dt Abertura</b-form-select-option
                                >
                                <b-form-select-option value="CBR2_DATA"
                                    >Licitação - 2ª Não Objeção - Dt CBR</b-form-select-option
                                >
                                <b-form-select-option value="PROPOSTA_PRECO"
                                    >Licitação - Dt Proposta Preços</b-form-select-option
                                >
                                <b-form-select-option value="REUNIAO_NEGOC"
                                    >Licitação - Dt Reunião Negociação</b-form-select-option
                                >
                                <b-form-select-option value="CBR3_DATA"
                                    >Licitação - 3ª Não Objeção - Dt CBR</b-form-select-option
                                >
                                <b-form-select-option value="ASSINATURA_CONTRATO"
                                    >Contrato - Dt Assinatura Contrato</b-form-select-option
                                >
                                <b-form-select-option value="OS">Contrato - Dt OS</b-form-select-option>
                                <b-form-select-option value="DATA_FINAL">Cálculo - Dt Final</b-form-select-option>
                                <b-form-select-option value="DATA_INICIAL">Marco - Dt Inicial</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <template v-slot:modal-footer>
                <b-button v-if="action !== 'view'" size="sm" @click="saveRecord()" variant="primary">
                    <i class="fas fa-check"></i> Gravar
                </b-button>
                <b-button size="sm" @click="() => $bvModal.hide('modal-tarefa-padrao')">Cancelar</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";

export default {
    name: "ModalTipoContrato",
    props: {
        tarefa: { type: Object, required: true },
        action: { type: String, required: true, default: "view" },
    },
    data: function() {
        return {
            tarefas: [],
            isLoading: false,
        };
    },
    methods: {
        validateRecord() {
            let _msg = "";

            if ((this.tarefa.descricao || "") === "") _msg = "Informe a Descrição";

            if (_msg !== "") {
                this.$toasted.info(_msg, {
                    duration: 4000,
                    keepOnHover: true,
                    className: "v-toasted-warning",
                });
                return false;
            }
            return true;
        },
        saveRecord() {
            if (!this.validateRecord()) return;

            if (this.action === "new") {
                axios
                    .post(`${baseApiUrl}/bid/tarefaspadrao`, this.tarefa)
                    .then(() => {
                        this.$bvModal.hide("modal-tarefa-padrao");
                        this.$emit("updated");
                    })
                    .catch((err) => {
                        showError(err);
                    });
            } else {
                axios
                    .put(`${baseApiUrl}/bid/tarefaspadrao/${this.tarefa.tarefa_id}`, this.tarefa)
                    .then(() => {
                        this.$bvModal.hide("modal-tarefa-padrao");
                        this.$emit("updated");
                    })
                    .catch((err) => {
                        showError(err);
                    });
            }
        },
        loadCombos() {
            this.isLoading = true;
            axios
                .get(`${baseApiUrl}/bid/tarefaspadrao/tipo`, {
                    data: { ind_tipo: this.tarefa.ind_tipo, ind_tp_revisao: this.tarefa.ind_tp_revisao },
                })
                .then((resp) => {
                  if(this.action == "new"){
                    if (resp.data.length == 0) 
                      this.tarefa.ordem_id = 10;
                    else 
                      this.tarefa.ordem_id = resp.data.ordem_id + 10;                      
                  }
                })
                .then(() => {
                    axios
                        .post(`${baseApiUrl}/bid/tarefaspadrao/listartipo`, {
                            ind_tipo: this.tarefa.ind_tipo,
                            ind_tp_revisao: this.tarefa.ind_tp_revisao,
                        })
                        .then((resp) => {
                            this.isLoading = false;
                            if (resp.data.length > 0) {
                                for (let i = 0; i < resp.data.length; i++) {
                                    resp.data[i][
                                        "descricao2"
                                    ] = `${resp.data[i]["ordem_id"]} - ${resp.data[i]["descricao"]}`;
                                }
                                this.tarefas = resp.data.filter((f) => {
                                    return (
                                        f.ind_tipo == this.tarefa.ind_tipo &&
                                        f.ind_tp_revisao == this.tarefa.ind_tp_revisao
                                    );
                                });
                            }
                        })
                        .catch((err) => {
                            this.isLoading = false;
                            showError(err);
                            console.log(err);
                        });
                })
                .catch((err) => {
                    this.isLoading = false;
                    console.log(err);
                    showError(err);
                });
        },
    },
};
</script>

<style></style>
